<template>
    <v-navigation-drawer v-model="show" app>
      <v-list nav>
        <v-list-item>
          <v-list-item-avatar>
            <v-img src="@/assets/user.png"></v-img>
          </v-list-item-avatar>
          {{ $store.state.user.username}}
        </v-list-item>
        <v-list-item v-if="companies.length > 1">
          <v-autocomplete solo :items="companies" v-model="selectedCompany" hide-details></v-autocomplete>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-group>
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-content>관제</v-list-item-content>
            </v-list-item>
          </template>

          <v-list-item to="/">
            <v-list-item-content>회사 현황</v-list-item-content>
          </v-list-item>
          <v-list-item to="/operation/map">
            <v-list-item-content>차량 위치</v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group>
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-content>기록</v-list-item-content>
            </v-list-item>
          </template>

          <v-list-item to="/history/days">
            <v-list-item-content>운행 이력</v-list-item-content>
          </v-list-item>
          <v-list-item to="/history/etas">
            <v-list-item-content>ETAS 파일 요청</v-list-item-content>
          </v-list-item>
          <v-list-item to="/history/non-receipt">
            <v-list-item-content>미수신 차량</v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group>
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-content>분석</v-list-item-content>
            </v-list-item>
          </template>

          <v-list-item to="/stat/devices/smartscore">
            <v-list-item-content>차량별 스마트 운전 기록</v-list-item-content>
          </v-list-item>
          <v-list-item to="/stat/drivers/smartscore">
            <v-list-item-content>운전자별 스마트 운전 기록</v-list-item-content>
          </v-list-item>
          <v-list-item to="/stat/drivers/smartscore-total">
            <v-list-item-content>운전자별 스마트 운전 통계</v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group>
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-content>관리</v-list-item-content>
            </v-list-item>
          </template>

          <v-list-item to="/settings/devices">
            <v-list-item-content>공회전 ON/OFF 관리</v-list-item-content>
          </v-list-item>
          <v-list-item to="/settings/areas">
            <v-list-item-content>공회전 제한 구역 관리</v-list-item-content>
          </v-list-item>
          <v-list-item to="/settings/set/areas">
            <v-list-item-content>공회전 제한 구역 설정</v-list-item-content>
          </v-list-item>
          <v-list-item to="/settings/set/params">
            <v-list-item-content>공회전 파라미터 설정</v-list-item-content>
          </v-list-item>
          <v-list-item to="/settings/groups">
            <v-list-item-content>노선 관리</v-list-item-content>
          </v-list-item>
          <v-list-item to="/settings/vehicles">
            <v-list-item-content>차량 관리</v-list-item-content>
          </v-list-item>
          <v-list-item to="/settings/drivers">
            <v-list-item-content>운전자 관리</v-list-item-content>
          </v-list-item>
          <v-list-item to="/settings/plans">
            <v-list-item-content>배차 관리</v-list-item-content>
          </v-list-item>
          <v-list-item to="/settings/company">
            <v-list-item-content>회사 정보</v-list-item-content>
          </v-list-item>
          <v-list-item to="/settings/password">
            <v-list-item-content>사용자 비밀번호 변경</v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
</template>

<script>
export default {
  computed: {
    isAdmin () {
      return this.$store.state.user.isAdmin || this.$store.state.user._cps.length > 1
    },
    selectedCompany: {
      get () {
        return this.$store.state.user._cp
      },
      set (_id) {
        this.$store.commit('selectCompany', _id)
      }
    },
    companies () {
      const companies = this.$store.state.user._cps.map(company => {
        return { value: company._id, text: company.name }
      })
        .sort((a, b) => {
          if (a.text > b.text) return 1
          else if (a.text < b.text) return -1
          else return 0
        })

      return companies
    },
    show: {
      get () {
        return this.$store.state.nav.show
      },
      set (value) {
        this.$store.commit('nav/setShow', value)
      }
    }
  }
}
</script>
